import gql from 'graphql-tag'

export const GET_ORDER_ITEM = gql`
  query GetOrderItem($orderItemId: ID!) {
    getOrderItem(orderItemId: $orderItemId)
  }
`

export const GET_ORDER_ITEMS = gql`
  query GetOrderItems($eventId: ID!, $pagination: Pagination) {
    getOrderItems(eventId: $eventId, pagination: $pagination) {
      items {
        id
        eventId
        name
        type
        price
        currency
        description
        organizationItemCategoryId
        createdAt
        updatedAt
        quantity
        initialQuantity
        currentlyAvailable
        itemMeta
        from
        to
        prepaidCoupon
        event {
          from
          soldOut
          extraModules {
            floorPlan
          }
        }
        organizationItemCategory {
          id
          name
          color
        }
        ticketSellerOrganizations {
          id
          name
        }
      }
      totalCount
      hasParterTickets
    }
  }
`

export const UPDATE_ORDER_ITEM_SECTION_SEATS = gql`
  mutation updateOrderItemSectionSeats(
    $orderItemId: ID!
    $seats: [String!]!
    $venueId: ID!
    $organizationSlug: String!
    $eventId: ID!
  ) {
    updateOrderItemSectionSeats(
      orderItemId: $orderItemId
      seats: $seats
      venueId: $venueId
      organizationSlug: $organizationSlug
      eventId: $eventId
    ) {
      id
      eventId
      name
      price
      currency
      description
      createdAt
      updatedAt
      quantity
      from
      to
      showIfSold
      sectionSeats
    }
  }
`
export const DISCONNECT_ORDER_ITEM_SECTION_SEATS = gql`
  mutation DisconnectOrderItemSectionSeats(
    $seats: [String!]!
    $venueId: ID!
    $organizationSlug: String!
    $eventId: ID!
  ) {
    disconnectOrderItemSectionSeats(
      seats: $seats
      venueId: $venueId
      organizationSlug: $organizationSlug
      eventId: $eventId
    ) {
      id
      eventId
      name
      price
      currency
      description
      createdAt
      updatedAt
      quantity
      from
      to
      showIfSold
      sectionSeats
    }
  }
`

export const CREATE_ORDER_ITEM = gql`
  mutation CreateOrderItem($eventId: ID!, $input: OrderItemInput!) {
    createOrderItem(eventId: $eventId, input: $input) {
      id
      eventId
      name
      type
      price
      currency
      description
      createdAt
      updatedAt
      quantity
      from
      to
      showIfSold
    }
  }
`

export const CREATE_GRATIS_ORDER_ITEM = gql`
  mutation CreateGratisOrderItem($eventId: ID!, $input: OrderItemInput!, $seats: [String!]) {
    createGratisOrderItem(eventId: $eventId, input: $input, seats: $seats)
  }
`

export const UPDATE_ORDER_ITEM = gql`
  mutation UpdateOrderItem(
    $orderItemId: ID!
    $input: OrderItemInput!
    $organizationId: ID
    $organizationSlug: String
  ) {
    updateOrderItem(
      orderItemId: $orderItemId
      input: $input
      organizationId: $organizationId
      organizationSlug: $organizationSlug
    ) {
      id
      eventId
      name
      type
      price
      currency
      description
      createdAt
      updatedAt
      quantity
      from
      to
      showIfSold
    }
  }
`
export const UPDATE_SALES_CHANNELS = gql`
  mutation UpdateSalesChannels($salesChannels: [ID!]!, $eventId: ID!) {
    updateSalesChannels(salesChannels: $salesChannels, eventId: $eventId)
  }
`

export const DELETE_ORDER_ITEM = gql`
  mutation DeleteOrderItem($orderItemId: ID!) {
    deleteOrderItem(orderItemId: $orderItemId)
  }
`

export const DELETE_ORDER_ITEMS = gql`
  mutation DeleteOrderItems($orderItemIds: [ID!]!) {
    deleteOrderItems(orderItemIds: $orderItemIds)
  }
`

export const GET_ONLINE_ORDER_ITEMS = gql`
  query getOnlineOrderItems($eventId: ID!) {
    getOnlineOrderItems(eventId: $eventId) {
      id
      eventId
      name
      type
      orderItemTemplateId
      price
      currency
      description
      membership
      prepaidCoupon
      createdAt
      updatedAt
      quantity
      initialQuantity
      currentlyAvailable
      from
      to
      showIfSold
      itemMeta
      organizationItemCategory {
        id
        name
        priority
        description
        color
        displayIfSoldOut
      }
    }
  }
`

export const CHANGE_TICKET_VALIDITY_DATES = gql`
  mutation ChangeTicketValidityDates(
    $organizationSlug: String!
    $orderItemId: ID!
    $validity: Boolean!
  ) {
    changeTicketValidityDates(
      organizationSlug: $organizationSlug
      orderItemId: $orderItemId
      validity: $validity
    )
  }
`
